// Local translations
export const T = {
  en_GB: {
    asset_classes: {
      title: "Asset Class Correlations",
      description: "Define correlation values between asset classes.",
      emptyMessage:
        "You need at least 2 asset classes to configure correlations. Add more asset classes in the Asset Classes tab.",
    },
    products: {
      title: "Product Correlations",
      description: "Define correlation values between products.",
      emptyMessage:
        "You need at least 2 products to configure correlations. Add more products in the Products tab.",
    },
  },
  nb_NO: {
    asset_classes: {
      title: "Aktivaklassekorrelasjoner",
      description: "Definer korrelasjonsverdier mellom aktivaklasser.",
      emptyMessage:
        "Du trenger minst 2 aktivaklasser for å konfigurere korrelasjoner. Legg til flere aktivaklasser i Aktivaklasser-fanen.",
    },
    products: {
      title: "Produktkorrelasjoner",
      description: "Definer korrelasjonsverdier mellom produkter.",
      emptyMessage:
        "Du trenger minst 2 produkter for å konfigurere korrelasjoner. Legg til flere produkter i Produkter-fanen.",
    },
  },
} as const;
